module.exports = "<app-sso></app-sso>"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/sso-page/sso-page.component.html
// module id = ./src/app/theme/sso-page/sso-page.component.html
// module chunks = main